export default __webpack_public_path__ + "static/media/639hz-love-connection.ffd46be9.ogg";